import { useContext, useEffect, useState } from "react";

// ----> IMPORTATION USETRANSLATION
import { useTranslation } from "react-i18next";


// REACT ROUTER DOM IMPORTATION
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

// ----> URLS IMPORTATION
import { urls } from "../../api-urls/api-urls";

// ----> USER CONTEXT IMPORTATION
import { UserContext } from "../../context/UserContext.jsx";

// COMPONENTS IMPORTATION
import { MsgRedirectComp } from "../../components/service/MsgRedirectComp.jsx";
// import { TourGuideComp } from "../../components/service/TourGuideComp.jsx";
import { LoadingComp } from "../../components/loading-comp/LoadingComp.jsx";
import { ListPendingServ } from "../../components/service/ListPendingServ.jsx";
import { BiClipBoardPulse, BiKeyboardFill, BiPCDisplay, BiPersonPlus, Send } from "../../components/icons/AppIcons.jsx";


import isot from "../../assets/Isotipo-2.svg"


// images
import Equipment from "../../assets/equipments.jpeg";

// custom hook importation
import { useFetchInfo } from "../../customs-hooks/service-calls/useFetchInfo.js";


// import notification
import { NotificationContext } from "../../context/NotificationContext.jsx";

// import lang context
import { LangContext } from "../../context/LangContext.jsx";

// constants
import { UrlClient } from "../../components/constants/constants.js";







export const NewCallComp = () => {


  // Use translation
  const [t] = useTranslation("global");


  // Use context
  const { user } = useContext(UserContext);


  // lang context
  const { lang } = useContext(LangContext);

  // GET the useNavigate
  const navigate = useNavigate();

  // GET the useLocation
  const location = useLocation();


  // notification context
  const { handleNotify } = useContext(NotificationContext);


  // GET the useSearchParams
  const [params] = useSearchParams();

  // const ID = params.get("id_equip");
  const VAL_PARAMS = params.get("id_equip") ?? params.get("id-equip");

  // custom hook 
  const { state, customer, equipment, pendingServ, onHandleChangeSending, onCloseServPend } = useFetchInfo(location, user, VAL_PARAMS);




  // ----> STATE DEFINITION
  const [form, setForm] = useState({
    cliente: "", equipo: "", etapa: 1, problema: "", temperature: "", IdTipServicio: 1, responsableIngreso: 0,
    encargado: "", telefono: "", correo: "", idEstatus: 1, codContacto: ""
  });
  const [stateL, setStateL] = useState({ id: 0, show: false });


  // funcion para cambiar el valor del formulario
  const onHandleChangeVal = (newVal = "", name = "") => {
    setForm((val) => ({ ...val, [name]: newVal }));
  };

  // funcion para validar los campos
  const validateForm = (form.cliente && form.equipo && form.temperature && form.problema.length > 3);


  // funcion para crear la llamada
  const onHandleCreateCall = async (event) => {
    event.preventDefault();

    let Error = 0;
    for (const prop in form) {
      if (["cliente", "equipo", "temperature", "problema"].includes(prop)) {
        if (form[prop] === "") {
          Error += 1;
        }
      }
    }

    if (Error > 0) {
      return handleNotify(true, t("NewCallComp.todos_los_camp"), true);
    }

    const END_POINT = `${urls.serviceEquipments}?language=${lang}&urlC=${UrlClient}`;

    try {
      onHandleChangeSending(true);

      const response = await fetch(END_POINT, {
        method: "POST",
        headers: {
          "Authorization": user?.token,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(form)
      });

      const data = await response.json();

      if (response.status === 201) {
        setStateL({ id: data?.id, show: true });
        setForm((val) => ({ ...val, problema: "", temperature: "" }));
      } else if (response.status === 500) {
        handleNotify(true, data?.msg, true);
      }

      onHandleChangeSending(false);

    } catch (error) {
      console.log(error);
    }
  };



  // useEffect para cargar los datos del usuario en el form
  useEffect(() => {
    setForm((val) => ({ ...val, cliente: user?.CodCliente, encargado: user?.Nombre, telefono: user?.Telefono, correo: user?.Correo, codContacto: user?.CodContacto }));
  }, [user]);



  useEffect(() => {

    setForm((val) => ({ ...val, equipo: state.equip }));

  }, [state.equip]);




  return (
    <>
      {
        state.isLoading && (<LoadingComp />)
      }
      {/* {
        state.modalLogin && (
          <LoginFloat setUserC={setUserContext} />
        )
      } */}
      {
        state.modalPend && (<ListPendingServ list={pendingServ} onClose={onCloseServPend} />)
      }
      {/* {
        // modal para el tour guide
        state.modalTourG && (
          <TourGuideComp />
        )
      } */}
      {
        // Msg redirect comp
        stateL.show && (
          <MsgRedirectComp idCall={stateL.id} />
        )
      }
      {/* {
        state.dataVisible && (
          <NavBarComp />
        )
      } */}
      {
        state.dataVisible && (
          <div className="container row-flex justify-center">

            <div className="card-report-case">
              <div className="row-flex justify-center">
                <img className="header-img-report" src={Equipment} alt="equipment" />
              </div>
              <h4 className="txt-center">{t("NewCallComp.report_falla")}</h4>

              <form onSubmit={onHandleCreateCall}>
                <div className="row-flex m-y-small">
                  <div className="col-5">
                    <strong>{t("NewCallComp.step")}</strong>
                  </div>
                  <div className="col-65 flex-grow-1">
                    <span className="txt-muted bg-green-b">{t("NewCallComp.firstStep")}</span>
                  </div>
                </div>
                <div className="row-flex m-y-small">
                  <div className="col-5 row-flex gap-small col-70-mob">
                    <BiPersonPlus />
                    <strong>{t("NewCallComp.customer")}</strong>
                  </div>
                  <div className="col-65 flex-grow-1">
                    <select
                      name="custo-selec"
                      value={form.cliente}
                      onChange={({ target }) => onHandleChangeVal(target.value, "cliente")}
                    >
                      <option value=""></option>
                      {
                        customer && customer.map((cust) => (
                          <option key={cust.CodCliente} value={cust.CodCliente}>{cust.Nombre}</option>
                        ))
                      }
                    </select>
                  </div>
                </div>

                <div className="row-flex">
                  <div className="col-5 row-flex gap-small col-70-mob">
                    <BiPCDisplay />
                    <strong>{t("NewCallComp.equipment")}</strong>
                  </div>
                  <div className="col-65 flex-grow-1">
                    <select
                      style={{ color: VAL_PARAMS !== "" ? "" : "#ff0000" }}
                      name="equip-selec"
                      value={form.equipo}
                      disabled>
                      <option value="">{t("NewCallComp.escanear_qr")}</option>
                      {
                        equipment && equipment.map((equi) => (
                          <option key={equi.CodEquipo} value={equi.CodEquipo}>{equi.Equipo}</option>
                        ))
                      }
                    </select>
                  </div>
                </div>

                <div className="row-flex m-y-small">
                  <div className="col-5 row-flex gap-small col-70-mob">
                    <BiClipBoardPulse />
                    <strong>{t("NewCallComp.temperature")}</strong>
                  </div>
                  <div className="col-65 flex-grow-1">
                    <select
                      name="temper-selec"
                      value={form.temperature}
                      onChange={({ target }) => onHandleChangeVal(target.value, "temperature")}>
                      <option>{t("NewCallComp.select_temp")}</option>
                      <option value="0">{t("NewCallComp.greenMeaning")}</option>
                      <option value="1">{t("NewCallComp.yellowMeaning")}</option>
                      <option value="4">{t("NewCallComp.redMeaning")}</option>
                    </select>
                  </div>
                </div>

                <div className="row-flex">
                  <div className="col-5 row-flex gap-small col-70-mob">
                    <BiKeyboardFill />
                    <strong>{t("NewCallComp.equipmentFailureDescrip")}</strong>
                  </div>
                  <div className="col-65 flex-grow-1">
                    <textarea
                      className="textarea-description"
                      name="fail-descrip"
                      value={form.problema}
                      onChange={({ target }) => onHandleChangeVal(target.value, "problema")} />
                  </div>
                </div>

                <div className="row-flex m-y-medium j-c-space-a">
                  <button type={state.sending || !validateForm ? "button" : "submit"} className={`btn-primary btn-flex ${validateForm ? "" : "disabled"}`}>
                    <Send />
                    {state.sending ? t("NewCallComp.enviando") : t("NewCallComp.enviar")}
                  </button>
                  <button type="reset" className="btn-secondary" onClick={() => navigate(-1, { replace: true })}>
                    {t("NewCallComp.atras")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )
      }


    </>
  );
};